var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.53 4.75c.315.628.132 3.317 0 4.845-.872 0-2.958.602-4.32.916-1.702.394-5.892 1.441-5.107 3.013.786 1.571 2.357 2.226 3.274 1.047.916-1.178 2.618-1.57 3.535-.785.917.785-6.678 6.809-8.642 8.25-1.964 1.44-3.404 2.094-1.048 3.142 2.357 1.047 3.798-.655 5.238-1.703 1.44-1.047 5.63-6.809 6.154-7.725.524-.918 1.179 1.046 1.179 2.356s0 7.07-1.179 7.594c-1.178.524-.13 3.012 1.179 4.19 1.047.943 2.357-.043 2.88-.654-.261-1.615-.785-5.762-.785-9.428 0-4.583 0-3.797.785-4.06.786-.261 2.488 3.798 5.63 7.726 3.144 3.928 5.762 2.88 7.334 1.702 1.257-.942-1.048-2.487-2.357-3.142-3.361-2.968-10.188-9.14-10.607-10.083-.523-1.177 2.62-1.308 4.714-.522 2.095.785 2.881.785 2.75-1.31-.13-2.095-3.695-1.96-6.023-1.57-2.357.392-2.357.523-2.226-1.572.13-2.095.916-.524 1.31-2.226C18.59 3.048 17.15 2 14.53 2c-2.618 0-.392 1.964 0 2.75z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLog);
export default __webpack_public_path__ + "static/media/LOG.bfce5b5732a668b4752adeb91717050a.svg";
export { ForwardRef as ReactComponent };